export { fetchPointMergeCandidates, previewPointMerge, executePointMerge } from "../repo/resourcePointMergeRepo";

/** 用完整选择生成比较键，使切换保留记录立即使旧预览失效。 */
export function pointMergeSelectionKey(targetId: string, sourceIds: string[]): string {
  return JSON.stringify([targetId, [...sourceIds].sort()]);
}
